import { serviceIconUrl } from '../lib/format.js';

/**
 * Renders a service's icon: the uploaded image when present, otherwise the emoji
 * fallback. `size` is the pixel box for the image (emoji inherits font-size).
 * Kept tiny and dependency-free so it can drop into chips, tiles and headers.
 */
export default function ServiceIcon({ service, size = 22, className = '' }) {
  const url = serviceIconUrl(service?.icon_image);
  if (url) {
    return (
      <img
        src={url}
        alt=""
        className={`service-icon-img ${className}`}
        style={{ width: size, height: size }}
      />
    );
  }
  return (
    <span className={className} aria-hidden="true">
      {service?.icon || '🩺'}
    </span>
  );
}
